export function withImageUrl(id: string) {
	return `/images/${id}`;
}
